import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-element-list',
  imports: [],
  templateUrl: './element-list.html',
  standalone: true,
})
export class ElementList {
  @Input()
  label: string = '';

  @Input()
  items: string[] = [];
}
